import React from 'react'

import '../styles/index.css'
import Landing from './Landing'
import AiSignals from './AiSignals'
import NeedToKnow from './NeedToKnow'
import TradeChart from './TradeChart'
import Plans from './Plans'
import Questions from './Questions'
import WeeklyWins from './WeeklyWins'
import Stories from './Stories'

const Index = () => {
  return (
    <>
      <div className="index">
        <div className="bggrad"></div>
        <Landing />
        <NeedToKnow />
        <AiSignals />
        <Questions />
        <TradeChart />
        <WeeklyWins />
        <Plans />
        <Stories />
      </div>
    </>
  )
}

export default Index